import { HolidayVillage } from "@mui/icons-material";
import { CardMedia } from "@mui/material";
import React from "react";
import logo from "../components/assets/image154.png";

const LoadingPage = () => {
  return (
    <div
      style={{
        background: "#000",
        width: "100%",
        height: "100vh",
      }}
    >
      <style>
        {`
          @keyframes pulse {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.1);
            }
            100% {
              transform: scale(1);
            }
          }
        `}
      </style>
      <div
        style={{
          fontSize: "2.5rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "900",
          color: "white",
          padding: "1vw",
          paddingTop: "40vh",
          animation: "pulse 2s infinite", // Use the defined animation name
        }}
      >
        <CardMedia
          component="img"
          sx={{ width: "70px", height: "70px" }}
          image={logo}
        />
      </div>
    </div>
  );
};

export default LoadingPage;